export const ACTION_LABELS: Record<string, string> = {
  price_down: "Снизить цену",
  price_up: "Повысить цену",
  set_min_price: "Установить мин. цену",
  disable_auto_actions: "Отключить автоакции",
  deactivate_action: "Деактивировать акцию",
  promo_on: "Включить промо",
  promo_off: "Отключить промо",
  recommend_supply: "Рекомендация поставки",
};

export const DIGEST_OVERALL_STATUS_LABELS: Record<string, string> = {
  critical: "Критично",
  attention: "Требует внимания",
  ok: "Всё штатно",
  insufficient_data: "Недостаточно данных",
  empty: "Нечего анализировать",
};

export const DIGEST_EVENT_SEVERITY_LABELS: Record<string, string> = {
  critical: "Критично",
  warning: "Внимание",
  info: "Информация",
  positive: "Положительно",
};

export const DIGEST_RUN_STATUS_LABELS: Record<string, string> = {
  created: "Ожидает",
  running: "Выполняется",
  completed: "Завершён",
  completed_with_warnings: "Завершён с предупреждениями",
  failed: "Не выполнен",
};

export const STATUS_LABELS: Record<string, string> = {
  proposed: "Предложено",
  approved: "Одобрено",
  rejected: "Отклонено",
  executing: "Выполняется",
  verifying: "Проверка",
  succeeded: "Успешно",
  failed: "Ошибка",
  draft: "Черновик",
  signed: "Подписано",
};
